import * as React from "react";
import Component from "../../AbstractComponent";
import { AddressInterface } from "../../../Interface/AddressInterface";
import Places from "../../../API/Google/Places";
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";

import TextField from "../../Partials/Material/TextField";

export class AddressSelector extends Component {
  public state: {
    address: any;
    predictions: any[];
    searchText: string;
    display: string;
    error: string;
    autoFocus: boolean;
    showTextField: boolean;
    required: boolean;
    labelText: string;
    onOpenEditAddressDialog: boolean;
    editabelText: string;
    errorDialog: any;
    copiedAddress: string;
  } = {
    address: {},
    predictions: [],
    searchText: "",
    display: "none",
    error: "",
    autoFocus: !!this.props.autoFocus,
    showTextField: true,
    required: false,
    labelText: "",
    onOpenEditAddressDialog: false,
    editabelText: "",
    errorDialog: null,
    copiedAddress: null
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    this.setState({
      searchText: !this.props.searchText ? "" : this.props.searchText,
      error: this.props.error,
      required: this.props.required,
      labelText: !!this.props.labelText ? this.props.labelText : "",
      address: this.props.selectedAddress ? this.props.selectedAddress : "",
    }, () => {
      //need this hack to show address rows in lookup component when we focus address field
      if(this.props.selectedAddress?.formattedAddress?.length > 0){
        this.setState({
          copiedAddress: this.props.selectedAddress?.formattedAddress
        }, () => {
          if(!!this.props.showListAfterFocus) {
            this.onChange(this.props.selectedAddress?.formattedAddress)
          }

          this.setState({
            copiedAddress: null
          })
        })
      }
    });


  }

   public componentWillReceiveProps(nextProps) {
     if (typeof nextProps.searchText !== "undefined" &&
         (nextProps.selectedAddress?.id !== this.props.selectedAddress?.id)
        ) {

       this.setState({
         searchText: !!nextProps.searchText ? nextProps.searchText : "",
       });
     }

     this.setState({
       error: nextProps.error,
       required: nextProps.required,
       labelText: !!nextProps.labelText ? nextProps.labelText : "",
     });
   }

  protected onChange = (event) => {
    let address;

    //need this hack to show address rows in lookup component when we focus address field
    if(this.state.copiedAddress){
      address = event;
    } else if (event?.target?.value) {
      address = event.target.value;
    }

    this.setState({
      searchText: address,
      display: !!address ? "block" : "none",
    });

    if (event?.currentTarget?.value?.length === 0) {
      return this.onClear();
    }

    if(this.props.countryList){
      Places.predictCountry(address).then(predictions => {
        this.setState({
          predictions: predictions
        }); 
        if (typeof this.props.onChange !== "undefined") {
          this.props.onChange.call(this, predictions);
        }
      });
    } else {
      Places.predict(address).then(predictions => {
        this.setState({
          predictions: predictions
        }); 
        if (typeof this.props.onChange !== "undefined") {
          this.props.onChange.call(this, predictions);
        }
      });
    } 
  }

  protected onChangeEditField = (event) => {
    const address = event.target.value;

    this.setState({
      editabelText: address,
    });
  }

  protected onKeyPress = (event) => {
    if (event.key === "Enter") {
      event.target.blur();
      event.preventDefault();
    }
  }

  protected onSelect = (result) => {
    Places.getAddress(result.placeId).then((address: AddressInterface) => {
      if (typeof this.props.onSelect !== "undefined") {
        this.props.onSelect.call(this, address);
      }

      if(this.props.sendFullAddress){
        let fullAddress = {}
        Object.keys(address || {}).forEach(key => {
          if (address[key] !== null) {
            fullAddress[key] = address[key];
          }
        });
        address.fullAddress = fullAddress
      }

      this.setState({
        address: address,
        searchText: address.formattedAddress,
        display: "none",
        showTextField: false,
      }, () => { // this hack need for rerender field and correct view label, because we have different size of label
        this.setState({
          showTextField: true
        }, () => {
          this.setState({
            autoFocus: true
          })
        })
      });
    });
  }

  protected onClear = () => {
    this.setState({
      address: {},
      searchText: "",
      predictions: [],
      showTextField: false,
    }, () => { // this hack need for rerender field and correct view label, because we have different size of label
      this.setState({
        showTextField: true
      }, () => {
        this.setState({
          autoFocus: true
        })
      })
    });

    if (typeof this.props.onClear !== "undefined") {
      this.props.onClear.call(this);
    }
    
    this.setState({
      autoFocus: true
    })
  }

  protected onBlur = () => {
    if (typeof this.state.address === "object" &&
    typeof this.state.address !== null &&
    Object.keys(this.state.address || {}).length > 0
    ) {
    this.setState({
      searchText: !!this.state.address?.formattedAddress ? this.state.address?.formattedAddress : "",
      predictions: [],
      display: "none",
    });
  } else {
    this.setState({
      address: {},
      searchText: "",
      predictions: [],
      display: "none"
    });
}
  }
  
  public onOpenEditAddressDialog = () => {
    this.setState({
      onOpenEditAddressDialog: true,
      editabelText: this.state.searchText
    });
  }

  public saveEditableAddress = () => {
    const address = {...this.state.address}

    address.formattedAddress = this.state.editabelText;
    if(address?.fullAddress?.formattedAddress) {
      address.fullAddress.formattedAddress = this.state.editabelText;
    }

    if(this.state.editabelText === ""){
      return this.setState({
        errorDialog: this.trans("this-field-is-not-valid")
      })
    }

    if (typeof this.props.onSelect !== "undefined") {
      this.props.onSelect.call(this, address);
    }

    this.setState({
      onOpenEditAddressDialog: false,
      searchText: this.state.editabelText,
      errorDialog: null
    }) 
  }
  
  public showFields = (): any => {
    if(this.state.predictions.length <= 0) {
      return (
        <ListItem
          key={`search-address-result`}
        >
          <ListItemText>
            <div className="no-results-address">{this.trans("dropdown-chargeobject-notfound")}</div>
          </ListItemText>
        </ListItem>
      );
    } else {
      return this.state.predictions
      .map((address: any) => {
        return (
          <ListItem
            className="search-address-result-li"
            onMouseDown={() => this.onSelect(address)}
            key={`search-address-result-${address.placeId}`}
          >
            <ListItemText>
              {address.description}
            </ListItemText>
          </ListItem>
        );
    });
    }

  }

  public render() {
    const showEditState = (
      typeof this.state.address === "object"
      && typeof this.state.address !== null
      && this.state?.address?.formattedAddress !== ""
      && Object.keys(this.state.address || {}).length > 0
      && !this.props.disabled
    );

    return (
      <div style={{position: "relative"}}>
        <div className="clear-button-container">
        { this.state.showTextField &&
          <form autoComplete='off'>
            <TextField
              autoComplete="off"
              name={this.props.name}
              className={`form-element full-size ${this.props.className || ''}`}
              type="text"
              onChange={this.onChange}
              value={this.state.searchText}
              label={this.state.labelText ? this.state.labelText : this.state.searchText && this.state.searchText.length >= 0 ?
                this.state.required ? this.trans("property-address") : this.trans("property-address") + this.trans(`field/optional`)
                : this.state.required ? this.trans("dropdown-searchforddress-label") : this.trans("dropdown-searchforddress-label") + this.trans(`field/optional`)}
              autoFocus={this.state.autoFocus}
              disabled={this.props.disabled}
              onBlur={this.onBlur}
              onKeyPress={this.onKeyPress}
              variant="standard"
              error={!!this.state.error}
            />
          </form>
        }
          {!!this.state.error && <div className="component-error-text">{this.state.error}</div>}
          {showEditState && (
            <div className="icon icon-ic-close clear-button" onClick={this.onClear}></div>
          )}

          {showEditState && (
            <div className="icon icon-ic-edit edit-address-button" onClick={this.onOpenEditAddressDialog}></div>
          )}
        </div>

        <div style={{
            display: this.state.display,
            overflow: "auto",
            maxHeight: this.props.maxHeight ? `${this.props.maxHeight}px` : "auto"
          }}
          className={`lookup-result-container address-selector ${this.props.styleInModal ? this.props.styleInModal : ""}`}
        >
          {this.showFields()}
        </div>

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.onOpenEditAddressDialog}
          title={this.trans("dialog/preprocess-editaddress/title")}
          content={
            <div>
              <div>{this.trans("dialog/preprocess-editaddress/info")}</div>
              <TextField
                autoComplete="off"
                className={"form-element full-size"}
                type="text"
                onChange={this.onChangeEditField}
                value={this.state.editabelText}
                label={this.trans("property-address")}
                autoFocus={this.state.autoFocus}
                variant="standard"
                error={!!this.state.errorDialog}
              />
              {!!this.state.errorDialog && <div className="component-error-text">{this.state.errorDialog}</div>}
            </div>
          }
          positiveButtonLabel={this.trans("dialog-button/save")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={this.saveEditableAddress}
          onDiscard={() => { this.setState({ onOpenEditAddressDialog: false, errorDialog: null}) }}
        />
      </div>
    );
  }
}
